import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-decline",
  "use": "icon-decline-usage",
  "viewBox": "0 0 9.673 5.39",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9.673 5.39\" id=\"icon-decline\">\r\n  <path id=\"icon-decline_路径_1080\" data-name=\"路径 1080\" d=\"M119.476,292.966h8.561a.555.555,0,0,1,.392.947l-4.281,4.28a.555.555,0,0,1-.785,0l-4.28-4.28a.555.555,0,0,1,.393-.947Z\" transform=\"translate(-118.92 -292.966)\" fill=\"#ec212d\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol